import type { HTMLAttributes } from 'react'
import { cn } from '../lib/cn'

/**
 * Superfície branca com fio de 1px — o único nível de "cartão" do sistema.
 * Nunca cartão dentro de cartão; nunca sombra. Divisões internas são fios (`SurfaceDivider`).
 */
export interface SurfaceProps extends HTMLAttributes<HTMLDivElement> {
  padding?: 'none' | 'sm' | 'md' | 'lg'
}

const paddings = { none: '', sm: 'p-4', md: 'px-6 py-5', lg: 'px-7 py-6' } as const

export function Surface({ padding = 'md', className, ...props }: SurfaceProps) {
  return (
    <div
      data-slot="surface"
      className={cn('border-hairline bg-surface border', paddings[padding], className)}
      {...props}
    />
  )
}

export function SurfaceDivider({ className, ...props }: HTMLAttributes<HTMLHRElement>) {
  return (
    <hr
      data-slot="surface-divider"
      className={cn('border-hairline border-0 border-t', className)}
      {...props}
    />
  )
}
